import request from './index'

// 获取管理员列表
export function getList(params) {
  return request({
    url: '/admin-users',
    method: 'get',
    params
  })
}

// 新增管理员
export function save(data) {
  return request({
    url: '/admin-users/save',
    method: 'post',
    data
  })
}

// 获取管理员详情
export function getDetail(id) {
  return request({
    url: '/admin-users/' + id,
    method: 'get'
  })
}

// 更新管理员
export function update(id, data) {
  return request({
    url: '/admin-users/update/' + id,
    method: 'post',
    data
  })
}

// 删除管理员
export function deleteAdmin(id) {
  return request({
    url: '/admin-users/delete/' + id,
    method: 'post'
  })
}
